import { FiEdit2 } from 'react-icons/fi'

import { Box, HStack, Text } from '@chakra-ui/react'

interface EditBadgeIProps {
  onClick?: (event: React.MouseEvent) => void
}

export const EditBadge = ({ onClick }: EditBadgeIProps) => {
  return (
    <HStack
      _groupHover={{
        opacity: 1,
      }}
      _hover={{
        backgroundColor: 'rgba(9, 30, 66, 0.12)',
      }}
      backgroundColor='rgba(9, 30, 66, 0.06)'
      borderRadius='2px'
      cursor='pointer'
      onClick={onClick}
      opacity={0}
      px='8px'
      py='4px'
      transition='ease-in-out'
      transitionDuration='300ms'
      transitionProperty='all'
    >
      <Box>
        <FiEdit2 color='#44546F' size={10} />
      </Box>
      <Text color='#44546F' fontSize='11px' fontWeight={500} lineHeight='16px'>
        Edit
      </Text>
    </HStack>
  )
}
